<template>
  <base-input
    type="number"
    :id="id"
    :value="value"
    @input="$emit('input', $event)"
    placeholder="€ 0"
    min="0"
    :label="label"
  ></base-input>
</template>

<script>
import BaseInput from "./BaseInput";

export default {
  components: {
    BaseInput
  },
  props: {
    value: undefined,
    id: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: false,
      default: ""
    }
  }
};
</script>

<style>
</style>